import React, { useState, useEffect, useRef } from "react"
import Select, { SelectChangeEvent } from "@mui/material/Select"
import { MenuItem, InputBase } from "@mui/material"
import { styled } from "@mui/material/styles"

interface SelectionBoxProps {
    data: { fieldName: string; value: string }
    options: string[]
    onValueChange: (fieldName: string, newValue: string) => void
    canEdit: boolean
}

// Custom styled components
const CustomSelect = styled(Select)({
    minWidth: "60px",
    maxWidth: "100%",
    width: "100%",
    fontSize: "16px",
    fontFamily: "inherit",
    display: "flex", // Ensure flex display for multiline
    alignItems: "center", // Align items to center
    whiteSpace: "normal", // Allow text to wrap
    wordBreak: "break-word", // Handle long words
})

const CustomInput = styled(InputBase)({
    padding: "0px",
    margin: "0px",
    whiteSpace: "normal", // Allow text to wrap
    wordBreak: "break-word", // Handle long words
    display: "flex", // Ensure flex display for multiline
    alignItems: "center", // Align items to center
})

const CustomMenuItem = styled(MenuItem)({
    padding: "5px",
    whiteSpace: "normal", // Allow text to wrap
    wordBreak: "break-word", // Handle long words
})

const SelectionBox: React.FC<SelectionBoxProps> = ({ data, options, onValueChange, canEdit }) => {
    const [value, setValue] = useState<string>(data.value as string)
    const textareaRef = useRef<HTMLTextAreaElement | null>(null)

    useEffect(() => {
        setValue(data.value as string)
    }, [data.value])

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = "auto"
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`
        }
    }, [value, canEdit])

    const handleChange = (event: SelectChangeEvent<unknown>) => {
        const newValue = event.target.value as string
        if (newValue !== value) {
            setValue(newValue)
            onValueChange(data.fieldName, newValue)
        }
    }

    const handleBlur = () => {
        if (value !== data.value) {
            onValueChange(data.fieldName, value)
        }
    }

    if (canEdit) {
        return (
            <div>
                <CustomSelect labelId="demo-simple-select-label" id="demo-simple-select" value={value} onChange={handleChange} onBlur={handleBlur} input={<CustomInput />}>
                    {options.map((option) => (
                        <CustomMenuItem value={option} key={option}>
                            {option}
                        </CustomMenuItem>
                    ))}
                </CustomSelect>
            </div>
        )
    } else {
        return <div>{value}</div>
    }
}

export default SelectionBox
